import { z } from "zod";
import { emailSchema } from "../common/email.js";

export const unsubscribeTokenPayloadSchema = z.object({
	user_id: z.uuid().optional(),
	email: emailSchema,
	community_id: z.uuid().optional(),
});

export type UnsubscribeTokenPayload = z.infer<typeof unsubscribeTokenPayloadSchema>;
